module.exports = __webpack_public_path__ + "img/重置密码.6b99a6ed.png";